/**
 * Web stub for react-native-star-rating-widget
 */
import React, { FC, useState } from 'react';

interface StarRatingProps {
  rating?: number;
  onChange?: (rating: number) => void;
  color?: string;
  emptyColor?: string;
  style?: any;
}

const StarRating: FC<StarRatingProps> = ({ rating = 0, onChange, color = '#FFD700', emptyColor = '#DDD', style }) => {
  const [localRating, setLocalRating] = useState(rating);

  const handleRating = (rate: number) => {
    setLocalRating(rate);
    onChange?.(rate);
  };

  return React.createElement(
    'div',
    { style: { display: 'flex', gap: '8px', ...style } },
    Array.from({ length: 5 }).map((_, idx) =>
      React.createElement('button', {
        key: idx,
        onClick: () => handleRating(idx + 1),
        style: {
          fontSize: '24px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: idx < localRating ? color : emptyColor,
        },
        children: '★',
      })
    )
  );
};

export default StarRating;
